import React, { useEffect, useMemo, useState } from 'react';
import CommonProductList from '../../components/CommonProductList';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
    pageLoading,
    pagesSubtitleSelector,
    paymentPageTokenSelector,
    pagesTariffsByProductSelector, pagesTariffsSelector,
} from '../../redux/selectors/pagesSelectors';
import { checkKey, setAccountFormIsVisible, setPageSubtitle } from '../../redux/actions/pagesActions';
import { FEATURED_PRODUCTS_PAIR } from '../../constants/constants';
import {
    cartAccountSelector,
    cartAutoUpgradeSelector,
    cartCartSelector,
    cartFeaturedIdsFromQuerySelector,
    cartFeaturedProductsListSelector,
    cartFlagsApplied,
    cartMainProduct,
    cartCurrencySelector,
} from '../../redux/selectors/cartSelector';
import AlertStatic from '../../components/General/AlertStatic';
import getProductTitle from '../../resolvers/getProductTitle';
import {
    setAppliedFlags,
    setAutoUpgrade,
    setFeaturedFromQuery, setPeriodFromQuery,
    setRenew, setTariffFromQuery,
} from '../../redux/actions/cartAction';
import isRenewAllowedByPeriod from '../../resolvers/isRenewAllowedByPeriod';
import { newFiltersPeriodByTariffSelector } from '../../redux/selectors/filtersSelector';
import Cards from '../../components/Cards';
import Skeleton from 'react-loading-skeleton';
import CTaskQueryParameter from '../../components/General/ctask_guery_parameter/CTaskQueryParameter'
import { authEmailSelector } from '../../redux/selectors/authSelectors'
import {
    productAvailableAccountsSelector,
    productCurrentProductIdSelector
} from "../../redux/selectors/productSelector";

import { useHeaderSlot } from "../../context/HeaderSlotContext";
import ProductMenu from "../../components/Menu/ProductMenu";
import init from "../../general/init";
import useQuery from "../../hooks/useQuery";
import TotalBill from "../../components/TotalBill";
import RegisterBlock from "../../components/Registraion/RegisterBlock";

function ProductsPage({
    checkKey,
    mainProduct,
    setFormIsVisible,
    setFeatured,
    featuredProductsFromQuery,
    appliedFlags,
    setAppliedFlags,
    account,
    periodsList,
    cart,
    setCartRenew,
    cartAutoUpgrade,
    setAutoUpgrade,
    currency,
    pageSubtitle,
    setPageSubtitle,
    tariffListByProduct,
    pageLoading,
    email,
}) {
    const query = useQuery();
    const dispatch = useDispatch();

    const [showError, setShowError] = useState(false);
    const [checkboxExtraPg, setCheckboxExtraPg] = useState(false);
    const { setHeaderContent } = useHeaderSlot();
    const title = useMemo(() => getProductTitle(mainProduct), [mainProduct]);
    const handleRenewChange = val => { setCartRenew({ renew: val }) };
    const doBoardDisabled = useMemo(() => {
        if(+mainProduct?.product_id === 7){
            return !(mainProduct?.period?.billing_period === "Month" && +mainProduct?.period?.interval === 12 &&
                mainProduct?.period?.interval_bonus_unit === "month" && +mainProduct?.period?.interval_bonus === 3);
        } else return true;
    },[mainProduct])
    const isRenewableState = () => {
        if ([2, 7].includes(mainProduct?.product_id)) {
            return true;
        }
        const period = mainProduct?.period ?? cart?.period;
        return period ? isRenewAllowedByPeriod(period) : true;
    };
    const handleAutoUpgradeChange = (value) => {
        setAutoUpgrade({ value });
    };
    const calculateFinalCost = (cost, intervalCount, intervalDiscount) => {
        const discountMultiplier = (100 - intervalDiscount) / 100;
        return cost * intervalCount * discountMultiplier;
    };

    const mainProductId = useSelector(productCurrentProductIdSelector);
    const accountsList = useSelector(productAvailableAccountsSelector);
    const pagesTariffs = useSelector(pagesTariffsSelector);

    const setPeriod = (data) => dispatch(setPeriodFromQuery(data))
    const setTariff = (data) => dispatch(setTariffFromQuery(data))

    // Init stands to a single entry point with a dedicated functional script(s)
    // start-up actions execution (like setting up "page opened" cookie).
    useEffect(() => {
        init({ mainProductId });
    }, [mainProductId]);

    useEffect(() => {
        setHeaderContent(<div className="header__left"><ProductMenu /> <RegisterBlock /> <TotalBill /></div>
        );
        return () => setHeaderContent(null);
    }, [setHeaderContent]);

    useEffect(() => {
        const tariffCurrent = Object.values(tariffListByProduct).filter(
            (tariff) => tariff?.tariff_id === mainProduct?.current_tariff_id
        );

        if (tariffCurrent && tariffCurrent[0]) {
            const filteredTariffs = Object.values(tariffListByProduct).filter(
                (tariff) => tariff.product_id === mainProduct?.product_id
            );

            let max = 0;

            filteredTariffs.forEach((tariff) => {
                Object.values(tariff.periods).forEach((period) => {
                    const finalCost = calculateFinalCost(
                        tariff.cost,
                        period.interval_count,
                        period.interval_discount
                    );

                    if (finalCost > max) {
                        max = finalCost;
                    }
                });
            });

            let extraPackagePrice =  max * mainProduct?.extra_package_rate ?? 1;
            const maxWithExtra = max + extraPackagePrice;

            if ([1,4].includes(mainProduct?.product_id)
                && mainProduct?.discount_amount > max
                && mainProduct?.discount_amount < maxWithExtra) {
                setCheckboxExtraPg(true)
            }

            if (maxWithExtra < mainProduct?.discount_amount) {
                setShowError(true);
            } else {
                setShowError(false);
            }

        } else {
            setShowError(false);
        }
    }, [mainProduct,tariffListByProduct]);

    useEffect(() => {
        checkKey();
    }, []);

    useEffect(() => {
        setPageSubtitle('');
    }, [mainProduct?.product_id]);

    useEffect(() => {
        if (!mainProduct?.product_id) {
            return;
        }
        // The next logic is responsible for auto selecting the featured product
        // on "cold" start (when no &featured= products in a parameter were supplied).
        // - featuredAutoSelect - identifies either user opened page w/o featured products specified
        // - featuredAutoSelectProduct - shows if featured products auto-selection was applied
        //   to a main product (so it works as a default action, but won't be re-applied
        //   when user re-visits the same main product).
        let featuredAutoSelect = !!appliedFlags.featuredAutoSelect;
        if (!featuredAutoSelect && featuredProductsFromQuery === '*') {
            featuredAutoSelect = true;
            setAppliedFlags({
                flags: { featuredAutoSelect },
            });
        }
        if (
            featuredAutoSelect &&
            !appliedFlags?.featuredAutoSelectProduct[mainProduct?.product_id]
        ) {
            setFeatured({
                featured: FEATURED_PRODUCTS_PAIR[mainProduct?.product_id]?.products ?? [],
            });
            setAppliedFlags({
                flags: {
                    featuredAutoSelectProduct: {
                        [mainProduct?.product_id]: true,
                    },
                },
            });
        }
    }, [appliedFlags.featuredAutoSelect, appliedFlags?.featuredAutoSelectProduct, featuredProductsFromQuery, mainProduct, setAppliedFlags, setFeatured]);

    useEffect(() => {
        if (
            accountsList?.find((item) => +item.account_id === +query.get('account'))?.trial &&
            +query.get('product_id') === 7
        ) {
            setPeriod({
                period: 'Month',
                interval: '1',
            });
        }
    }, [accountsList, query, setPeriod]);

    useEffect(() => {
        if (!mainProduct || !mainProduct.valid_till) return;
        if(!query.get('tariff_id') && mainProduct.valid_till){
            const date = new Date()
            if(new Date(mainProduct.valid_till) > date){
                if(((new Date(mainProduct.valid_till) - date)/ (1000 * 60 * 60 * 24)) <= 30){
                    setTariff({tariff_id:mainProduct.current_tariff_id})
                } else {
                    const tariffsLimited = Object.values(pagesTariffs)?.filter(item => +item.product_id === +mainProduct.product_id && item?.services !== 0).sort((a,b) => a.cost - b.cost);
                    const tariffsUnlimited = Object.values(pagesTariffs)?.filter(item => +item.product_id === +mainProduct.product_id && item?.services === 0).sort((a,b) => a.cost - b.cost);
                    const tariffs = tariffsLimited.concat(tariffsUnlimited);
                    const currentTariffIndex = tariffs.map(item => +item.tariff_id).indexOf(+mainProduct.current_tariff_id);
                    if(currentTariffIndex+1 <= tariffs.length){
                        setTariff({tariff_id:`${tariffs[currentTariffIndex+1]?.tariff_id}`})
                    } else {
                        setTariff({tariff_id:`${mainProduct.current_tariff_id}`})
                    }
                }
            } else {
                setTariff({tariff_id:mainProduct.current_tariff_id})
            }
        }
    }, [mainProduct, pagesTariffs, query, setTariff]);

    return (
        <div className="container">
            <CTaskQueryParameter />
            <>
                <h1 className={'title-1 text--center mb-8 tablet-ml-16 tablet-mr-16'}>
                    {pageLoading ? <Skeleton width={300} /> : title}
                </h1>

                {showError ? (
                    <div className={'notification__message mb-60 mt-0'}>
                        Your discount exceeds the maximum license cost. Please contact{' '}
                        <a className={'header__link'} href="https://cleantalk.org/my/support">
                            support
                        </a>
                    </div>
                ) : (
                    < >
                        <div className={'subtitle mb-28 tablet-mb-16 text--center'}>
                            {pageSubtitle}
                        </div>
                        <CommonProductList checkboxExtraPg={checkboxExtraPg} />
                        <div className={'flex flex--end section'}>
                            <div className={'section__cell checkbox-list'}>
                                {pageLoading && <Skeleton height={115} className={'mb-13'} />}
                                {periodsList &&
                                    // - Renew for SSL (5) is not supported on backend side
                                    // - Renew for doBoard (7) and DB API can be renewed on any period (months).
                                    mainProduct?.product_id !== 5 &&
                                    (mainProduct?.product_id === 2 ||
                                        mainProduct?.product_id === 7 ||
                                        !!Object.values(periodsList ?? {})?.filter(
                                            // Not clear the initial intention of the condition there,
                                            // based on "reverse-analysis" it looks like it should work like:
                                            // "if there is at least one "1 year" period among available - allow a renewal switcher".
                                            // Also is not allowed renewal for SSL products.
                                            (period) => isRenewAllowedByPeriod(period)
                                        )?.length) && (
                                        <div className="checkbox">
                                            <input
                                                type="checkbox"
                                                id={`renew-${mainProduct?.product_id}`}
                                                className="checkbox__input"
                                                disabled={!doBoardDisabled || !isRenewableState()}
                                                checked={doBoardDisabled && (isRenewableState() && cart?.renew)}
                                                onChange={(e) =>
                                                    handleRenewChange(e.target.checked)
                                                }
                                            />

                                            <label
                                                htmlFor={`renew-${mainProduct?.product_id}`}
                                                className={'checkbox__label text-3'}
                                            >
                                                Automatically renew {mainProduct?.product_name}{' '}
                                                license
                                            </label>
                                            <div
                                                className={
                                                    'checkbox__note text-4 pt-2 color--gray flex flex--column'
                                                }
                                            >
                                                <span>
                                                    Auto-renewal is available only for periods less
                                                    than one year.
                                                </span>
                                                <i className={'mt-10'}>
                                                    Currency rate is estimated and provided by{' '}
                                                    <a
                                                        className={'color--gray'}
                                                        href="http://finance.yahoo.com/currency-converter/"
                                                        target="_blank"
                                                    >
                                                        Yahoo finance
                                                    </a>
                                                    , it may be different compared to a payment
                                                    provider.
                                                </i>
                                            </div>
                                        </div>
                                    )}

                                {mainProduct?.product_id === 2 /* black list DB API */ && (
                                    <div className="checkbox">
                                        <input
                                            type="checkbox"
                                            id={`auto-upgrade-${mainProduct?.product_id}`}
                                            className="checkbox__input"
                                            disabled={!isRenewableState()}
                                            checked={cartAutoUpgrade}
                                            onChange={(e) =>
                                                handleAutoUpgradeChange(e.target.checked)
                                            }
                                        />

                                        <label
                                            htmlFor={`auto-upgrade-${mainProduct?.product_id}`}
                                            className={'checkbox__label text-3'}
                                        >
                                            Auto upgrade of the tariff when the limit is exceeded
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                        {currency?.currency && currency?.currency === 'RUB' && (
                            <div className={'notification__message'}>
                                <p>
                                    Если у вас возникли проблемы с оплатой в рублях, то
                                    воспользуйтесь сервисом{' '}
                                    <a href="https://cleantalk-shop.ru" target="_blank">cleantalk-shop.ru</a> или{' '}
                                    <a href="https://pay-saas.ru" target="_blank">pay-saas.ru</a>.
                                </p>
                            </div>
                        )}

                        {/* If tariff is selected & is not a subscribable */}
                        {mainProduct?.tariff && !mainProduct?.tariff?.allow_subscribe && (
                            <AlertStatic
                                alertType="warning"
                                message="You are using old package that has been de-listed from our price list. But you can renew the package or choose one of packages from current price list."
                            />
                        )}
                        {(mainProduct?.product_id === 7 && email && !account && (
                            <AlertStatic
                                alertType="info"
                                message="There are no doBoard licenses in your account. First, log in to your doBoard account, then "
                                link={{ href: 'https://app.doboard.com/login', title: 'create a company' }}
                            />
                        ))
                        ||
                        (mainProduct?.product_id === 5 && email && !cart?.domains?.length && (
                            <AlertStatic
                                alertType="info"
                                message="There is no domain selected. Add at least one domain to your "
                                link={{ href: 'https://cleantalk.org/my/?cp_mode=ssl', title: 'SSL Dashboard.' }}
                            />
                        )
                        )|| (
                            <><Cards setAccountFormIsVisible={setFormIsVisible} /></>
                        )}
                    </>
                )}
            </>
        </div>
    );
}

const mapStateToProps = (state, props) => ({
    account: cartAccountSelector(state),
    featuredProductsFromQuery: cartFeaturedIdsFromQuerySelector(state),
    paymentPageToken: paymentPageTokenSelector(state),
    mainProduct: cartMainProduct(state),
    featuredProductsList: cartFeaturedProductsListSelector(state),
    appliedFlags: cartFlagsApplied(state),
    periodsList: newFiltersPeriodByTariffSelector(state, props),
    cart: cartCartSelector(state),
    cartAutoUpgrade: cartAutoUpgradeSelector(state),
    currency: cartCurrencySelector(state),
    pageSubtitle: pagesSubtitleSelector(state),
    tariffListByProduct: pagesTariffsByProductSelector(state),
    pageLoading: pageLoading(state),
    email: authEmailSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkKey: (data) => dispatch(checkKey(data)),
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setFeatured: (data) => dispatch(setFeaturedFromQuery(data)),
    setAppliedFlags: (data) => dispatch(setAppliedFlags(data)),
    setCartRenew: (data) => dispatch(setRenew(data)),
    setAutoUpgrade: (value) => dispatch(setAutoUpgrade(value)),
    setPageSubtitle: (value) => dispatch(setPageSubtitle(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
